import { appConfig } from '../init/getAppConfig';
import { getBrand } from './getBrand';
import { EnvType } from '../app/types/enum';

export function getChatApiBaseUrl(): string {
  let apiBaseUrl = appConfig.chatApiBaseUrl;
  if (apiBaseUrl !== 'https://chatapps-services.rogers.com') {
    return apiBaseUrl;
  }
  if (appConfig.envType == EnvType.dev) {
    apiBaseUrl = appendEnvToUrl(apiBaseUrl, 'dev');
  }
  if (appConfig.envType == EnvType.qa) {
    apiBaseUrl = appendEnvToUrl(apiBaseUrl, 'qa');
  }
  if (getBrand().code == 'f' && window.location.href.includes('fido')) {
    apiBaseUrl = apiBaseUrl.replace('rogers.com', 'fido.ca');
  }
  return apiBaseUrl;
}

function appendEnvToUrl(apiBaseUrl: string, env: string): string {
  const splits = apiBaseUrl.split('https://');
  if (splits.length == 2) {
    return `https://${env}-${splits[1]}`;
  }
  return apiBaseUrl;
}
